// ── [C86] Cross-product idea ingress (IK→MP) — Owner-side client ─────────────
//
// Authority: ADR-MP-013 + integration guide v1.1.
// Tracker:   OPEN_PROMISES.md [C86] Phase 3 (this commit).
//
// These helpers wrap the Owner-gated endpoints (`/api/mp/ideas`,
// `/api/mp/ideas/{uuid}/transition`, `/api/mp/ideas/untriaged-count`) for the
// Ideas Inbox page. The bearer-gated ingress endpoint (POST `/api/mp/ideas`)
// is NEVER called from the browser — that surface is for sending agents only.

import { apiClient } from "./api";

/**
 * Slim public count (no auth) — feeds the topbar badge so we can render the
 * badge before Auth0 silent-renew completes.
 * @returns {Promise<{count:number}>}
 */
export async function fetchIdeasUntriagedCount() {
  try {
    const { data } = await apiClient.get("/mp/ideas/untriaged-count");
    return data || { count: 0 };
  } catch {
    return { count: 0 };
  }
}

/**
 * Owner-gated list of intake rows. Pass `state` as a comma-separated string
 * to scope to a subset of the state machine (e.g.
 * `"untriaged,needs-info:target-app-assignment"`).
 *
 * @param {{state?:string, source?:string, target_app?:string, limit?:number, token:string}} opts
 */
export async function fetchIdeas({ state, source, target_app, limit, token }) {
  const params = {};
  if (state) params.state = state;
  if (source) params.source = source;
  if (target_app) params.target_app = target_app;
  if (limit) params.limit = limit;
  const { data } = await apiClient.get("/mp/ideas", {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data || [];
}

/**
 * Owner-driven state transition. `transition` shape per
 * `IdeaTransitionRequest` in `ideas_service.py`:
 *   { target_state, note?, ratified_as?, rejected_reason?, deferred_condition?, new_target_app? }
 */
export async function transitionIdea(intakeUuid, transition, token) {
  const { data } = await apiClient.post(
    `/mp/ideas/${encodeURIComponent(intakeUuid)}/transition`,
    transition,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
}
